import type { HomologationStatus as HomologationStatusValue } from '@/components/ProductCard/types'
import { VpIcon, VpIconButton } from '@vtmn-play/react/headless'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { getHomologationStatusTranslationKey } from '@/constants/homologation'
import { getIconFromStatus, HOMOLOGATION_STATUS_COLOR } from './utils'

export function HomologationStatus({
  status,
  onOpenModal,
}: Readonly<{
  status: HomologationStatusValue
  onOpenModal: () => void
}>) {
  const { t } = useTranslation()
  const canOpenModal = status === 'NOT OK' || status === 'PENDING'

  return (
    <div
      className={clsx('homologation-status-container', status.toLowerCase().replaceAll(' ', '_'))}
      style={{ color: HOMOLOGATION_STATUS_COLOR[status] }}
      data-testid="homologation-status-container"
    >
      <VpIcon name={getIconFromStatus(status)} size={20} />
      <div data-testid="homologation-status-label" className="homologation-status-label">
        {t(`products-page.product-card.homologation_statuses.${getHomologationStatusTranslationKey(status)}`)}
      </div>
      {canOpenModal && (
        <VpIconButton
          onClick={onOpenModal}
          aria-label={t('aria-label.open-homologation-modal')}
          name="eye"
          variant="tertiary"
          data-testid="manufacture-country_eye-icon"
          size="small"
        >
          <VpIcon name="eye" size={20} />
        </VpIconButton>
      )}
    </div>
  )
}
